var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.20938 4.0813H3.99097C3.59554 4.0813 3.21631 4.23838 2.9367 4.51799C2.65708 4.79761 2.5 5.17684 2.5 5.57227V16.0091C2.5 16.4045 2.65708 16.7837 2.9367 17.0634C3.21631 17.343 3.59554 17.5001 3.99097 17.5001H14.4278C14.8232 17.5001 15.2024 17.343 15.4821 17.0634C15.7617 16.7837 15.9188 16.4045 15.9188 16.0091V10.7907",
    stroke: "#7BD755",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8005 2.96319C15.0971 2.66661 15.4993 2.5 15.9187 2.5C16.3382 2.5 16.7404 2.66661 17.037 2.96319C17.3335 3.25976 17.5002 3.662 17.5002 4.08142C17.5002 4.50083 17.3335 4.90307 17.037 5.19964L9.95485 12.2818L6.9729 13.0273L7.71839 10.0453L14.8005 2.96319Z",
    stroke: "#7BD755",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnCheckbox);
export default __webpack_public_path__ + "static/media/Un-Checkbox.a29f58f6aa15b043b466e41eb0eb8055.svg";
export { ForwardRef as ReactComponent };